import React from "react";

const Payment = () => {
  return (
    <div>
      <h2>Soon, a payment method will be available...</h2>
    </div>
  );
};

export default Payment;
